var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect } from 'react';
export var useServiceApi = function (_a) {
    var fetchBanEligibility = _a.fetchBanEligibility, fetchSalesTransactionId = _a.fetchSalesTransactionId, fetchSubEligibility = _a.fetchSubEligibility;
    // Ensures that the eligibility isn't called more than once for the same ban.
    var _b = useState(true), shouldFetchBanEligibilty = _b[0], setShouldFetchBanEligibilty = _b[1];
    var _c = useState(), ban = _c[0], setBan = _c[1];
    var _d = useState(), sub = _d[0], setSub = _d[1];
    var _e = useState(), creditClass = _e[0], setCreditClass = _e[1];
    var _f = useState(), orderType = _f[0], setOrderType = _f[1];
    /** Do not modify the defaults of the salesTransactionId unless needed as it affects the functionality of the Account Selector
     * undefined => the sales-transaction-id endpoint was never called, this will stop the banEligibility from being called
     * null => the sales-transaction-id endpoint was called and returned an error, make the banEligibility call and record a value of null in session for salesTransactionId
     * string => the sales-transaction-id endpoint was called and returned a value, make the banEligibility call and record the value in session for salesTransactionId
     */
    var _g = useState(), salesTransactionId = _g[0], setSalesTransactionId = _g[1];
    var _h = useState({
        apiResolved: false,
        aalStatus: false,
        isFetching: false // mainly used by UI to show loading indicator
    }), aalRes = _h[0], setAalRes = _h[1];
    var _j = useState({
        apiResolved: false,
        eligibility: true
    }), subEligibility = _j[0], setSubEligibility = _j[1];
    var _k = useState(false), isFetchingBanElig = _k[0], setFetchingBanElig = _k[1];
    var _l = useState(false), isFetchingSalesTxId = _l[0], setFetchingSalesTxId = _l[1];
    // We want credit class, sales tx id and ban eligibility to resolve before showing the AAL button
    var isFetching = isFetchingBanElig || isFetchingSalesTxId;
    var setApiQueries = function (queries) {
        if (queries) {
            var sub_1 = queries.sub, selectedBan = queries.ban, credit = queries.creditClass, selectedOrderType = queries.orderType;
            setOrderType(selectedOrderType);
            if (sub_1) {
                setSub(sub_1);
                // if the button is triggered for a multi ban account or a new sub is selected on a single ban account,
                // then we need to use the session data or ban and credit class are undefined when the subEligibility call is made.
                if (!ban)
                    setBan(selectedBan);
                if (!creditClass)
                    setCreditClass(credit);
            }
            else {
                setBan(selectedBan);
                setCreditClass(credit);
                setShouldFetchBanEligibilty(true);
            }
        }
        else {
            setAalRes({
                apiResolved: false,
                aalStatus: false,
                isFetching: false
            });
            setSubEligibility({
                apiResolved: false,
                eligibility: false
            });
        }
    };
    var getBanEligibility = function (queryParams) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setFetchingBanElig(true);
                    return [4 /*yield*/, fetchBanEligibility(queryParams)];
                case 1:
                    response = _a.sent();
                    setAalRes({
                        apiResolved: true,
                        aalStatus: response.data.aal,
                        isFetching: false
                    });
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _a.sent();
                    setAalRes({
                        apiResolved: true,
                        aalStatus: false,
                        isFetching: false
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setFetchingBanElig(false);
                    setShouldFetchBanEligibilty(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getSubEligibility = function (queryParams) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchSubEligibility(queryParams)];
                case 1:
                    response = _a.sent();
                    setSubEligibility({ apiResolved: true, eligibility: response.data.renewal });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    setSubEligibility({ apiResolved: true, eligibility: false });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var retrieveSalesTransactionId = function (queryParams) { return __awaiter(void 0, void 0, void 0, function () {
        var response, salesTransactionId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFetchingSalesTxId(true);
                    return [4 /*yield*/, fetchSalesTransactionId(queryParams)];
                case 1:
                    response = _a.sent();
                    setFetchingSalesTxId(false);
                    salesTransactionId = response.data.salesTransactionId;
                    setSalesTransactionId(salesTransactionId);
                    return [2 /*return*/];
            }
        });
    }); };
    var getSalesTransactionId = function (queryParams) { return __awaiter(void 0, void 0, void 0, function () {
        var err_3, retryErr_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 7]);
                    return [4 /*yield*/, retrieveSalesTransactionId(queryParams)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 2:
                    err_3 = _a.sent();
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, retrieveSalesTransactionId(queryParams)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    retryErr_1 = _a.sent();
                    // this will set {errors:loginIncomplete:true} in session when handleMutateSession is called
                    setSalesTransactionId(null);
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (ban) {
            var banNumber = ban.ban, type = ban.type, subType = ban.subType;
            var queries = { type: type, subType: subType, banNumber: banNumber, orderType: orderType };
            getSalesTransactionId(queries).catch(function (e) { return null; });
        }
    }, [ban]);
    // Add a line CTA depends on fetching states for 1) sales tx and 2) ban eligibility.
    // We want to send this combined loading state to acc selector for AAL button for
    // smoother UX (eg. avoid skeleton showing and hiding)
    useEffect(function () {
        setAalRes(__assign(__assign({}, aalRes), { isFetching: isFetching }));
    }, [isFetching]);
    // If the ban or the creditClass changes, call the service api for the aal eligibility status
    useEffect(function () {
        var _a = ban !== null && ban !== void 0 ? ban : {}, banNumber = _a.ban, type = _a.type, subType = _a.subType;
        var queries = { banNumber: banNumber, type: type, subType: subType, creditClass: creditClass, salesTransactionId: salesTransactionId };
        // an undefined salesTransactionId means that the sales-transaction-id endpoint has not been resolved
        // do not call the banEligibility endpoint until it resolves
        if (ban && creditClass && salesTransactionId !== undefined && shouldFetchBanEligibilty) {
            getBanEligibility(queries); // eslint-disable-line
        }
    }, [ban, creditClass, salesTransactionId]);
    // If the sub changes, call the service api for the sub eligibility status
    useEffect(function () {
        var _a = ban !== null && ban !== void 0 ? ban : {}, banNumber = _a.ban, type = _a.type, subType = _a.subType;
        var queries = { banNumber: banNumber, sub: sub, type: type, subType: subType, creditClass: creditClass, salesTransactionId: salesTransactionId, orderType: orderType };
        if (ban && creditClass && sub) {
            getSubEligibility(queries); // eslint-disable-line
        }
    }, [sub, creditClass]);
    return {
        aalRes: aalRes,
        setApiQueries: setApiQueries,
        salesTransactionId: salesTransactionId,
        subEligibility: subEligibility
    };
};
